import { render, staticRenderFns } from "./TOCTemp1.vue?vue&type=template&id=59346a32&scoped=true&"
import script from "./TOCTemp1.vue?vue&type=script&lang=js&"
export * from "./TOCTemp1.vue?vue&type=script&lang=js&"
import style0 from "./TOCTemp1.vue?vue&type=style&index=0&id=59346a32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59346a32",
  null
  
)

export default component.exports